const develop: string = "https://api.staging2.signedly.com";

const production: string = "https://l0ads.signedly.com";

const ngRok: string = "https://86fd-2401-4900-53e6-99d9-68f1-dcf0-b38-72f2.in.ngrok.io";

const qa: string = "https://api.signedly.com";

// const dev: string = "https://uatapi.signedly.com";
const dev: any = process.env.REACT_APP_BASE_URL;
const uat: string = "https://uatapi.signedly.com";

const config: {
    develop: string;
    production: string;
    ngRok: string;
    qa: string;
    dev: any;
    uat: string;
} = {
    production: production,
    develop: develop,
    ngRok: ngRok,
    qa: qa,
    dev: dev,
    uat: uat
};

export default config.dev;
